import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "hotel-list-item__image" }
const _hoisted_3 = ["alt"]

import BookmarkHotelButton from '@lmt-rpb/BookmarkHotelButton/BookmarkHotelButton.vue';
import HotelImageSlider from '@lmt-rpb/HotelImageSlider/HotelImageSlider.vue';
import HotelListItemOffer from '@lmt-rpb/HotelListItemOffer/HotelListItemOffer.vue';
import HotelListItemReview from '@lmt-rpb/HotelListItemReview/HotelListItemReview.vue';
import HotelListItemHeader from '@lmt-rpb/HotelListItemHeader/HotelListItemHeader.vue';
import HotelListItemFeatures from '@lmt-rpb/HotelListItemFeatures/HotelListItemFeatures.vue';
import HotelListItemStorno from '@lmt-rpb/HotelListItemStorno/HotelListItemStorno.vue';

import type { Ref } from 'vue';
import { computed, ref } from 'vue';
import { addEnabledParams } from '@/components/common/services/url';
import { flexOptions } from '@/js/data/flex-options';

import type { HotelListItemType } from '@/interfaces/hotel-list-types/hotel-list-types';
import type { DiscountHotelPriceOffer } from '@/interfaces/neusta-discount-price';
import HotelListItemFavouriteDetails from '@lmt-rpb/HotelListItemFavouriteDetails/HotelListItemFavouriteDetails.vue';

type Props = {
	item: HotelListItemType;
	showSuns?: boolean;
	isFavoriteList?: boolean;
	hotelListType: string;
	itemIndex?: number;
	discount?: DiscountHotelPriceOffer | undefined;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'HotelListItem',
  props: {
    item: {},
    showSuns: { type: Boolean, default: false },
    isFavoriteList: { type: Boolean },
    hotelListType: {},
    itemIndex: { default: 1 },
    discount: { default: undefined }
  },
  setup(__props: any) {

const rootElement: Ref<HTMLElement | undefined> = ref();

const props = __props;

const showRegion = computed(() => props.hotelListType === 'COUNTRY' || props.hotelListType === 'REGIONGROUP');

const review = computed(() => {
	const { Ratings, NumberOfRatings } = props.item;
	return { Ratings, NumberOfRatings };
});

const offer = computed(() => {
	if (props.item.PackageOffer) {
		return {
			...props.item.PackageOffer,
			Pricing: props.item.Pricing,
		};
	}
	if (props.item.AccommodationOffer) {
		return {
			...props.item.AccommodationOffer,
			Pricing: props.item.Pricing,
		};
	}
	return null;
});

const hasOfferFeatures = computed(() => {
	const offerFeatures = props.item.OfferFeatures;
	if (!offerFeatures) return false;

	return flexOptions.some((key) => typeof offerFeatures[key] === 'string' && offerFeatures[key]?.trim() !== '');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    ref_key: "rootElement",
    ref: rootElement,
    class: _normalizeClass(["hotel-list-item", { 'is-favorite-page': _ctx.isFavoriteList }]),
    href: _unref(addEnabledParams)(_ctx.item.Hotel.URL)
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.item.NumberOfImages && _ctx.item.NumberOfImages > 0)
        ? (_openBlock(), _createBlock(HotelImageSlider, {
            key: 0,
            "iff-code": _ctx.item.Hotel.IffCode,
            alt: _ctx.item.Hotel.Name,
            "number-of-images": _ctx.item.NumberOfImages,
            class: "hotel-list-item__slider",
            "item-index": _ctx.itemIndex
          }, null, 8 /* PROPS */, ["iff-code", "alt", "number-of-images", "item-index"]))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "hotel-list-item__slider",
            src: "data:image/gif;base64,R0lGODdhEgAMAIABAPD2/////ywAAAAAEgAMAAACDYSPqcvtD6OctNqLVQEAOw==",
            alt: _ctx.item.Hotel.Name
          }, null, 8 /* PROPS */, _hoisted_3)),
      _createVNode(BookmarkHotelButton, {
        item: _ctx.item,
        class: "hotel-list-item__bookmark-icon",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
      }, null, 8 /* PROPS */, ["item"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([{ 'is-favorite-list': _ctx.isFavoriteList }, "hotel-list-item__body"])
    }, [
      _createVNode(HotelListItemHeader, {
        class: "hotel-list-item__header",
        hotel: _ctx.item.Hotel,
        location: _ctx.item.Location,
        "show-region": showRegion.value,
        "show-suns": _ctx.showSuns
      }, null, 8 /* PROPS */, ["hotel", "location", "show-region", "show-suns"]),
      (review.value.NumberOfRatings !== undefined && review.value.Ratings !== undefined && review.value.NumberOfRatings > 0)
        ? (_openBlock(), _createBlock(HotelListItemReview, {
            key: 0,
            review: review.value,
            class: "hotel-list-item__review"
          }, null, 8 /* PROPS */, ["review"]))
        : _createCommentVNode("v-if", true),
      (_ctx.item.PopularAttributes && _ctx.item.PopularAttributes.length !== 0)
        ? (_openBlock(), _createBlock(HotelListItemFeatures, {
            key: 1,
            class: "hotel-list-item__features",
            "popular-attributes": _ctx.item.PopularAttributes
          }, null, 8 /* PROPS */, ["popular-attributes"]))
        : _createCommentVNode("v-if", true),
      (!_ctx.isFavoriteList)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(HotelListItemStorno, {
              "offer-feature": hasOfferFeatures.value,
              class: "hotel-list-item__storno",
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
            }, null, 8 /* PROPS */, ["offer-feature"]),
            (offer.value)
              ? (_openBlock(), _createBlock(HotelListItemOffer, {
                  key: 0,
                  class: "hotel-list-item__offer",
                  href: `${_unref(addEnabledParams)(_ctx.item.Hotel.URL)}#offers`,
                  offer: offer.value,
                  discount: _ctx.discount
                }, null, 8 /* PROPS */, ["href", "offer", "discount"]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createBlock(HotelListItemFavouriteDetails, {
            key: 3,
            details: "16.6. - 05.7., 1 Woche, 2 Erw., 1 Kind, inkl. Flug ab Berlin Brandenburg lorem ipsum very lonk text such text very information",
            class: "hotel-list-item__favorite-details"
          }))
    ], 2 /* CLASS */)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})